<div #chartContainer class="chart-container"></div>

<div class="score" layout-vertical layout-align-items-center>
  @if (isHidden()) {
    <span [class]="emptyScoreClass()">∗∗∗</span>
  } @else if (isEmpty()) {
    <rt-icon
      name="rating-thumbs-up-down"
      [size]="scoreIconSize()"
      colorToken="colorIconLowDisabled"
    />
    <span [class]="emptyScoreClass()">—</span>
  } @else {
    <rt-evaluation-rating-score
      [evaluationScale]="evaluationScale()"
      [averageRatingScorePercent]="score().average"
      orientation="vertical"
      [iconSize]="scoreIconSize()"
      [fontSize]="scoreFontSize()"
      [fontWeight]="scoreFontWeight()"
      textColor="strong"
    />
  }
  @if (showScoreCaption()) {
    <span class="score-caption">
      {{ 'app.evaluation_tab.summary_details.score' | translate }}
    </span>
  }
</div>
